<template>
    <v-app id="form">
            <v-form ref="form">
        <v-layout row>
                
                <v-flex lg6> 
                
                    <v-row class="ml-lg-n4 ml-1 mt-lg-12 mt-2">

                            <v-col cols="1" lg="12" xs="12">

                                <v-row style="width:280px !important;">
                                    <div class="mt-lg-2"> <v-img src="@/assets/images/Monitoring/calendar.svg" /> </div>
                                     <v-autocomplete
                                        v-model="month"
                                        :items="months"
                                        item-text="month"
                                        item-value="no"
                                        dense
                                        class="ml-lg-0"
                                        label="MONTH TO REVIEW 평가 월 "
                                        @change="getNoOfWeeks()"
                                        :rules="inputRules"
                                    ></v-autocomplete>  

                                </v-row>

                            </v-col>

                    </v-row>

                </v-flex>

                <v-flex lg6> 

                    <v-row class="ml-lg-9 ml-1 mt-lg-12 mt-2" justify-lg="end" justify-sm="start">

                            <v-col cols="1" lg="12" xs="12">

                                <v-row style="width:280px !important;">
                                    <div class="mt-lg-2"> <v-img src="@/assets/images/Monitoring/student.svg" contain/> </div>
                                   
                                    <v-text-field
                                            v-model="englishName"
                                          
                                            class="mt-n3"
                                            
                                            label="ENGLISH NAME 영어 이름 "
                                            :rules="inputRules"
                                            :error-messages="engNameValid ? 'Wrong English Name Format' : ''"
                                        
                                        />

                                </v-row>

                            </v-col>

                    </v-row>

                </v-flex>

                <v-flex lg12 class="mt-lg-2">

                    <div class="font-weight-bold font-14"> <span> Please rate the instructors. 강사를 평가해 주세요. * </span> </div>

                    <v-layout row class="mt-lg-2 font-11 px-lg-5">
                        
                        <v-flex lg1>

                            <div class="font-weight-bold"> <span> 5 pts </span> </div>
                        
                        </v-flex>
                        <v-flex lg10 class="ml-lg-2">

                            <div> <span> 개선 필요. 강사는 학생들로부터 많은 컴플레인 받으며 수업의 퀄리티가 좋지 못하고 경우를 포함해 많은 실수를 만드는 경향이 있습니다. </span> </div>
                        
                        </v-flex>

                        <v-flex lg1 class="mt-lg-3">

                            <div class="font-weight-bold"> <span> 10 pts </span> </div>
                        
                        </v-flex>
                        <v-flex lg10 class="ml-lg-2 mt-lg-3">

                            <div> <span> 표준. 강사는 학생들로부터 최소한의 컴플레인을 받고있으며 좋은 수업 퀄리티를 유지합니다 </span> </div>
                        
                        </v-flex>

                        <v-flex lg1 class="mt-lg-3">

                            <div class="font-weight-bold"> <span> 15 pts </span> </div>
                        
                        </v-flex>
                        <v-flex lg10 class="ml-lg-2 mt-lg-3">

                            <div> <span> 만족함. 강사는 학생들로부터의 컴플레인이 없고 좋은 수업 퀄리티를 유지합니다. </span> </div>
                        
                        </v-flex>

                        <v-flex lg1 class="mt-lg-3">

                            <div class="font-weight-bold"> <span> 20 pts </span> </div>
                        
                        </v-flex>
                        <v-flex lg10 class="ml-lg-2 mt-lg-3">

                            <div> <span> 훌륭함. 강사는 인기가 많아 찾는 학생이 많습니다. 학생들로부터 좋은 피드백을 받고있습니다. </span> </div>
                        
                        </v-flex>

                    </v-layout>
                    


                </v-flex>

                <v-flex lg12 class="mt-lg-10">

                     <v-data-table :loading="loadingStatus" loading-text="Loading... Please wait" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" dense :headers="headers" :footer-props="{'items-per-page-options': [10,20,30,40,50]}" :items-per-page="10"  :items="tables" item-key="id" class="elevation-0 table-rating">
                 
                             <template slot="item" slot-scope="props">

                                        <tr>
                                                <td class="text-left"> {{props.index+1 +". "+props.item.instructor}} </td>
                            
                                                 <td class="text-center "> <v-radio-group v-model="props.item.id" > <v-radio value="5"> </v-radio> </v-radio-group>  </td>
                                                 <td class="text-center "> <v-radio-group v-model="props.item.id" > <v-radio value="10"></v-radio>   </v-radio-group> </td>
                                                 <td class="text-center "> <v-radio-group v-model="props.item.id">  <v-radio value="15"></v-radio>  </v-radio-group> </td>
                                                 <td class="text-center "> <v-radio-group v-model="props.item.id"> <v-radio value="20"></v-radio>  </v-radio-group> </td>
                                            

                                        </tr>

                                    </template>


                     </v-data-table> 

                     <div v-if="notAllTutor" class="red--text"> 
                            <span> *Please Rate All Tutors </span>     
                    </div>


                </v-flex>
                 <v-flex lg12 class="mt-lg-5 pb-5">
                                        
                                        <v-layout justify-end>
                                            <v-btn color="rgb(0, 99, 158)" class="white--text" @click="SaveReview()"> SUBMIT </v-btn>
                                        </v-layout>

                                    </v-flex>  
                
        </v-layout>
            </v-form>


            <!-- dialogbox -->


        <v-dialog
                            transition="dialog-bottom-transition"
                            max-width="100%"
                            v-model="dialogshow"
                            persistent
                          >
                            <v-card style="background-color:#000C17 !important">
                              <v-card-actions class="justify-end">
                                <v-btn
                                  text
                                  @click="(dialogshow = false)"
                                >
                                  <span class="white--text"> Close </span>
                                </v-btn>
                              </v-card-actions>
                              <v-card-text>

                                <div
                                  class="text-h3 white--text"
                                >
                                  Data Successfully Saved!
                                </div>
                              </v-card-text>
                              <v-card-actions class="justify-end">
                                <v-btn
                                  text
                                  @click="(dialogshow = false)"
                                >
                                  <span class="white--text"> Close </span>
                                </v-btn>
                              </v-card-actions>
                            </v-card>
        </v-dialog>

    </v-app>
</template>
<script>
import Vue from 'vue'
import axios from 'axios'
Vue.use(axios)
export default {
    name:'managerReviewForm',
    data: () => ({
        month:'',
        months: [{'no':'01','month':'January 1월'}, {'no':'02','month':'February 2월'}, {'no':'03','month':'March 3월'}, {'no':'04','month':'April 4월'}, {'no':'05','month':'May 5월'}, {'no':'06','month':'June 6월'}, {'no':'07','month':'July 7월'}, {'no':'08','month':'August 8월'}, {'no':'09','month':'September 9월'}, {'no':'10','month':'October 10월'}, {'no':'11','month':'November 11월'}, {'no':'12','month':'December 12월'},],
        tables:[],
        getTutor:[],
        itemPerPage:0,
        englishName:'',
        inputRules: [
                v => v.length >= 1 || "Item is Required"
            ],
        notAllTutor:false,
        sendData:false,
        timestamp: new Date(),
        engNameValid:false,
        dialogshow: false,
    }),
    computed: {
       headers(){ return  [{

          
          text: 'Instructor',
          align: 'center',
          sortable: false,
          value: 'instructor',
          class: "grey lighten-2"
        },
        { text: '5 pts',align: 'center', value: 'three' , class: "grey lighten-2", sortable: false,},
        { text: '10 pts',align: 'center', value: 'five' , class: "grey lighten-2", sortable: false,},
        { text: '15 pts',align: 'center', value: 'seven' , class: "grey lighten-2", sortable: false,},
        { text: '20 pts',align: 'center', value: 'ten' , class: "grey lighten-2", sortable: false,},
        
        ]},
        posts(){
            return{
                 actionTaken:'insertdata',
                 event:"managerReview",
                 month_year:this.timestamp.getFullYear()+"-"+this.month+"-01",
                 engName:this.englishName,
                 scores:[],
                 timestamp: this.timestamp.getFullYear()+"-"+(this.timestamp.getMonth() >= 9 ? (this.timestamp.getMonth()+1) : "0"+(this.timestamp.getMonth()+1))+"-"+(this.timestamp.getDate() > 9 ? this.timestamp.getDate() : "0"+this.timestamp.getDate())+" "+(this.timestamp.getHours() > 9 ? this.timestamp.getHours() : "0"+this.timestamp.getHours())+":"+(this.timestamp.getMinutes() > 9 ? this.timestamp.getMinutes() : "0"+this.timestamp.getMinutes())+":"+(this.timestamp.getSeconds() > 9 ? this.timestamp.getSeconds() : "0"+this.timestamp.getSeconds())

            }
        }
    },
    mounted(){
        this.getOtheTutor()
    },
    methods:{
        
        getOtheTutor(){
      
        axios.get('https://phone.megatalking.com/origin/api/monitoring.php?action=getTutors')
        //.then(response=>console.warn(response.data))
        .then(response=>{
        
          let tutorlist = response.data
         this.itemPerPage = tutorlist.length 
              for(let i = 0 ; i<=tutorlist.length ; i++){
                    
                  
                  this.getTutor.push(tutorlist[i].tutor_id)
                  this.tables.push({
                                    id:tutorlist[i].tutor_id,
                                    tutor_id:tutorlist[i].tutor_id,
                                    instructor:tutorlist[i].tutor_full_name,
                                    lastVal:0,
                                    tutorCount: 0
                                    })
                 this.tables.sort(function(a, b){
                              return a.instructor.localeCompare(b.instructor);
                            })
                    

               }
               
              })

      },

      async SaveReview(){

        this.notAllTutor = false
        
        let validate_eng_name = new RegExp('^([A-Z][a-z]*)$')

        this.engNameValid = false

         if(this.$refs.form.validate()){
            

             if(validate_eng_name.test(this.englishName)){



                    this.posts['scores'] = []            
                
                        for(let x =0 ; x < this.tables.length ; x++){
                            
                                    if(this.tables[x].id =="5" || this.tables[x].id =="10" || this.tables[x].id =="15" || this.tables[x].id =="20" ){
                                        
                                            this.posts['scores'].push({

                                                        
                                                            tutor_id:this.tables[x].tutor_id,
                                                            score:this.tables[x].id
                                                        
                                            })
                                            this.sendData = true

                                    } else {
                                        this.posts = []
                                        this.sendData =false
                                        this.notAllTutor = true
                                        break;

                                    }

                                    if(x == (this.tables.length-1) ){
                                        
                                        this.sendDataResult()


                                    }

                        }

                 


             } else {

                        this.engNameValid = true

             }


            

         }

      },

      sendDataResult(){

          axios.post('http://localhost/megatalking/performance/tutorperf.php',this.posts).then(response=>{

                        if(response.data == 'success' || response.data == 'successUpdate'){
                            return (this.dialogshow = true)
                        
                        }

                        

               }).catch(error=>console.log('this is the error '+error))

               
               
      }
 }
}
</script>
<style scoped>
#form{
    background-color: rgb(246, 246, 246);
}
.font-11
{
    font-size:11px
}
.font-14{
    font-size:14px
}
.font-9
{
    font-size:9px
}
</style>